var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 5,
    viewBox: "0 0 20 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61538 2.25C4.61538 3.49264 3.5822 4.5 2.30769 4.5C1.03319 4.5 0 3.49264 0 2.25C0 1.00736 1.03319 0 2.30769 0C3.5822 0 4.61538 1.00736 4.61538 2.25Z",
    fill: "#1C2743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3077 2.25C12.3077 3.49264 11.2745 4.5 10 4.5C8.7255 4.5 7.69231 3.49264 7.69231 2.25C7.69231 1.00736 8.7255 0 10 0C11.2745 0 12.3077 1.00736 12.3077 2.25Z",
    fill: "#1C2743"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.25C20 3.49264 18.9668 4.5 17.6923 4.5C16.4178 4.5 15.3846 3.49264 15.3846 2.25C15.3846 1.00736 16.4178 0 17.6923 0C18.9668 0 20 1.00736 20 2.25Z",
    fill: "#1C2743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDots);
export default __webpack_public_path__ + "static/media/ico-dots.49cb3177c42ef22843f1364fffb9227f.svg";
export { ForwardRef as ReactComponent };